import { NgModule } from '@angular/core';
import { AssetVersionPipe } from './asset-version.pipe';

@NgModule({
  declarations: [AssetVersionPipe],
  exports: [AssetVersionPipe],
})
export class AssetVersionPipeModule {}
